
import { common as enCommon } from './en/common';
import { common as hiCommon } from './hi/common';

const messages = {
  en: {
    common: enCommon
  },
  hi: {
    common: hiCommon
  }
};

export default messages;
